import React, {useContext,useEffect,useState} from 'react'
import {TramitesContextProvider} from '../contexto/TramitesContext'
//import {Listado} from '../componentes/Listado'
import {Listado} from '../componentes/ListadoOld'
// import {Tramite} from '../componentes/Tramite';
// import {Dialogos} from '../../../componentes/MUI/Dialogos'

import Main from '../../../componentes/Main'
import { Typography } from '@material-tailwind/react';
import { useContextoGlobal } from '../../../Context/contextoGlobal';

export const Tramites = ({usuario})=>{
    const [tramiteSeleccionado,setTramiteSeleccionado] = React.useState(null)
    const [refresh,setrefresh] = useState(null)
    const {esCelular} = useContextoGlobal();

    return <TramitesContextProvider>
                <Main>
                        <div className='w-full'>
                            <div className='w-full'>   
                                <Typography variant="h4" className="w-full flex justify-center mb-4">
                                    Trámites
                                </Typography>
                                <Listado refresh={refresh} seleccionarTramite = {setTramiteSeleccionado}/>
                            </div>
                        </div>
                </Main> 
            </TramitesContextProvider> 
}

